/**
 * Tracking page URLs for UK carriers.
 * Backend can send carrier + tracking number; we build the link for the customer.
 * Or backend can send a pre-built tracking_url.
 */

export const CARRIER_TRACKING: Record<string, { name: string; url: (num: string) => string }> = {
  evri: {
    name: 'Evri',
    url: () => 'https://www.evri.com/track-a-parcel',
  },
  hermes: {
    name: 'Evri',
    url: () => 'https://www.evri.com/track-a-parcel',
  },
  royalmail: {
    name: 'Royal Mail',
    url: (num) => `https://www.royalmail.com/portal/rm/track?trackNumber=${encodeURIComponent(num.trim())}`,
  },
  'royal mail': {
    name: 'Royal Mail',
    url: (num) => `https://www.royalmail.com/portal/rm/track?trackNumber=${encodeURIComponent(num.trim())}`,
  },
  dpd: {
    name: 'DPD',
    url: (num) => `https://www.dpd.co.uk/apps/tracking/?reference=${encodeURIComponent(num.trim())}`,
  },
  dhl: {
    name: 'DHL',
    url: (num) => `https://www.dhl.com/en-en/home/tracking.html?tracking-id=${encodeURIComponent(num.trim())}`,
  },
  ups: {
    name: 'UPS',
    url: (num) => `https://www.ups.com/track?tracknum=${encodeURIComponent(num.trim())}`,
  },
  fedex: {
    name: 'FedEx',
    url: (num) => `https://www.fedex.com/fedextrack/?trknbr=${encodeURIComponent(num.trim())}`,
  },
};

/** Normalise carrier name for lookup (e.g. "Royal Mail" -> "royal mail"). */
function normaliseCarrier(carrier: string): string {
  return (carrier || '').toLowerCase().trim();
}

/**
 * Get the tracking URL for a carrier and optional tracking number.
 * Evri doesn't support number-in-URL so we return the track page; customer pastes number there.
 */
export function getTrackingUrl(carrier: string, trackingNumber?: string): string {
  const key = normaliseCarrier(carrier);
  const entry = CARRIER_TRACKING[key];
  if (!entry) return '';
  return entry.url(trackingNumber || '');
}

export function getCarrierDisplayName(carrier: string): string {
  const key = normaliseCarrier(carrier);
  return CARRIER_TRACKING[key]?.name || carrier;
}
